import { create } from "@storybook/theming/create";
import designTokens from "../core/design-tokens";
import { version } from "../package.json";

const tokens = designTokens(false);

// IMPORTANT: Currently each repo maintain it's own theme
export default create({
    base: "light",
    brandTitle: `Dell Design System ${version}`,
    brandUrl: "https://www.delldesignsystem.com",
    // Typography
    fontBase: `${tokens["font-family-base"]} !important`,
    fontCode: `${tokens["font-family-monospace"]} !important`,
});
